import * as ActionType from '../../core/ActionType';
import { ApiCallBeginAction } from '../api/Action';
import { PesagemService } from './Service';
import { setErrorResponse, setSuccessResponse } from '../responses/Action';
import * as Constants from '../../utils/constants';


/**
 * 
 * @param {Objeto completo contendo a lista de pesagem} pesagemObject 
 */
export const getPesagensResponse = pesagemObject => ({
    type: ActionType.GET_PESAGENS_RESPONSE,
    pesagemObject
});

export const addPesagemResponse = pesagemObject => ({
    type: ActionType.ADD_PESAGEM_RESPONSE,
    pesagemObject
});


/**
 * Método responsável por buscar todos os pesagens da API
 */
export function getPesagensAction() {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        dispatch(ApiCallBeginAction());

        try {
            let pesagemObject = await PesagemService.getPesagens()
            dispatch(getPesagensResponse(pesagemObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}

export function getPesagensFullAction(abertos) {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        dispatch(ApiCallBeginAction());
        
        try {
            let pesagemObject = await PesagemService.getPesagensFull(abertos)
            dispatch(getPesagensResponse(pesagemObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}

export function desativarPesagemByIdAction(id) {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        // dispatch(ApiCallBeginAction());
        
        try {
            await PesagemService.desativarPesagem(id)
            // dispatch(getPesagensResponse(pesagemObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}

export function setImpressaoTermica(values) {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        // dispatch(ApiCallBeginAction());
        
        try {
            await PesagemService.postImpressaoTermica(values)
            // dispatch(getPesagensResponse(pesagemObject));
        } catch (error) {
            throw error;
            // dispatch(setErrorResponse(error));
        }
    };
}


export function getPesagemByIdAction(id) {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        dispatch(ApiCallBeginAction());
        
        try {
            let pesagemObject = await PesagemService.getPesagemById(id)
            dispatch(getPesagensResponse(pesagemObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}

export function savePesagemAction(pesagem) {
    return async function (dispatch) {
        await dispatch(setSuccessResponse(null));
        await dispatch(setErrorResponse(null));
        await dispatch(ApiCallBeginAction());
        try {
            let pesagemObject;

            if (pesagem.id) pesagemObject = await PesagemService.putPesagem(pesagem);
            else pesagemObject = await PesagemService.postPesagem(pesagem);

            await dispatch(setSuccessResponse(Constants.DESCRICAO_SUCCESS));
            // await dispatch(addPesagemResponse(pesagemObject));
            return pesagemObject;
        } catch (error) {
            dispatch(setErrorResponse(error));
            throw error;
        }


    }
}

export function atualizarPesagemObject(pesagemObject) {
    return async function (dispatch) {
        try {
            dispatch(getPesagensResponse(pesagemObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}

